import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DocumentsService {
  patchLoading = signal(false);
  saveLoading = signal(false);
  sendSignLoading = signal(false);
  lodgeNowLoading = signal(false);
  disabledHeaderBtn = signal(false);
  showVoidEnvelope = signal(false);
  showSendEmailBtn = signal(false);
  showNextBtn = signal(false);
  showSendPaperBtn = signal(false);
}
